
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import CityCard from '../components/CityCard/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    NewSwiper,
    CityCard
  }
})
export default class CitiesPage extends Vue {
  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  get CityStore() {
    return this.$store.$tonghao.Cities
  }

  get HomeStore() {
    return this.$store.$homeV2
  }

  prev() {
    if (!this.swiper) return
    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return
    this.swiper.handleNext()
  }

  handleToIntro() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
